import * as React from "react";

function SvgIcons8ToggleIndeterminate(props, ref) {
  return (
    <svg viewBox="0 0 32 32" {...{ ...props, ref }}>
      <path d="M9 7c-4.959 0-9 4.041-9 9v1h.203C.725 21.468 4.396 25 9 25h14c4.604 0 8.275-3.532 8.797-8H32v-1c0-4.959-4.041-9-9-9H9zm7 2c3.878 0 7 3.122 7 7s-3.122 7-7 7-7-3.122-7-7 3.122-7 7-7zm5.643 0H23c3.877 0 7 3.123 7 7s-3.123 7-7 7h-1.357A8.985 8.985 0 0025 16a8.985 8.985 0 00-3.357-7z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8ToggleIndeterminate);
